import getCsrf from '../modules/getCsrf';

const requests = {
    getRequest(options) {
        let url = new URL(window.location.protocol + window.location.host + window.location.pathname);
        let params = options.params ?? {};
        url.search = new URLSearchParams(params).toString();

        return fetch(url, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'accept': 'application/json, text/javascript, */*; q=0.01',
                'X-Requested-With': 'XMLHttpRequest',
                'pragma': 'no-cache',
                'cache-control': 'no-cache',
            }
        }).then(response => {
            return response.json();
        }).then((data) => {
            if (data.status === 200) {
                return data;
            } else {
                throw new Error(data.message);
            }
        }).catch(err => console.info(err));
    },

    async postRequest(options) {

        let url = new URL(window.location.protocol + window.location.host + window.location.pathname);
        let params = options.params ?? {};

        let token = await getCsrf().then(response => response);
        url.search = new URLSearchParams(params).toString();

        let data = options.data;

        // Set CSRF Token
        data[token.name] = token.value;

        return fetch(params.action, {
            method: 'POST',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Content-Type': 'application/json',
                'accept': 'application/json, text/javascript, */*; q=0.01',
                'pragma': 'no-cache',
                'cache-control': 'no-cache',
            },
            body: JSON.stringify(data)
        }).then(response => {
            return response.json();
        }).then((data) => {
            if (data.status === 200) {
                return data;
            } else {
                throw new Error(data.message);
            }
        }).catch(err => console.error(err));
    },

    getJsonRequest(options) {
        let url = options.hasOwnProperty('url') ? new URL(options.url) : new URL(window.location.protocol + window.location.host + window.location.pathname);
        let params = options.params ?? {};
        url.search = new URLSearchParams(params).toString();

        return fetch(url, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        }).then(response => {
            return response.json();
        }).then((data) => {
            return data;
        }).catch(err => console.info(err));
    },
}

export { requests as default };
